import { Box } from '@mui/material';
import Button from '../../foundation/Button';

type Props = {
    onClick: () => void;
}

const ElpStickyCtaMobile = ({ onClick }: Props): JSX.Element => (
    <Box
        sx={{
            display: { xs: 'flex', md: 'none' },
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1200,
            backgroundColor: 'white',
            borderTop: '1px solid #eee',
            padding: '0.75rem 1.25rem',
            boxShadow: '0 -4px 16px rgba(0,0,0,0.1)',
        }}
    >
        <Button color="primary" size="large" fullWidth onClick={onClick}>
            התחילו לפרסם עם חבילת משרות
        </Button>
    </Box>
);

export default ElpStickyCtaMobile;
